import { __awaiter, __generator } from "tslib";
import { bytesToHex } from '@office-start/hex-string-utility';
export function getDigest(subtleCrypto, toHash, salt, encode) {
    return __awaiter(this, void 0, void 0, function () {
        var saltedValue, encodedSaltedValue, digestBuffer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    saltedValue = toHash + salt;
                    return [4 /*yield*/, encode(saltedValue)];
                case 1:
                    encodedSaltedValue = _a.sent();
                    return [4 /*yield*/, subtleCrypto.digest({ name: 'SHA-256' }, encodedSaltedValue)];
                case 2:
                    digestBuffer = _a.sent();
                    return [2 /*return*/, bytesToHex(new Uint8Array(digestBuffer))];
            }
        });
    });
}
//# sourceMappingURL=getDigest.js.map